import { jsx as _jsx } from "react/jsx-runtime";
import { upgradeProductToTrialIds } from 'self-service-api/constants/Trials';
import TrialActivationButton from '../_core/trial/activation/TrialActivationButton';
import { useMultiTrialTrackingProps } from '../_core/trial/useMultiTrialTrackingProps';
import { TRIAL_STANDARD_DURATION } from '../_core/trial/constants';
import { mapPurchaseMotionApiName } from '../ums/utils';

const updateUpgradeData = props => {
  const {
    upgradeData: {
      app,
      screen,
      uniqueId,
      duration
    }
  } = props;
  const isScreenUrlPath = screen.split('/').length > 1;
  const source = isScreenUrlPath ? uniqueId // Special case for UMS modals (uniqueId === upgradeKey)
  : `${app}-${screen}-trial-button-${uniqueId}`;
  return Object.assign({}, props, {
    upgradeData: Object.assign({}, props.upgradeData, {
      apiName: mapPurchaseMotionApiName(props.canViewNewSeats, props.upgradeData.upgradeProduct, 'UITrialActivationButton', props.upgradeData.apiName),
      source,
      trialId: upgradeProductToTrialIds[props.upgradeData.upgradeProduct] || null,
      duration: duration || TRIAL_STANDARD_DURATION
    })
  });
};

const UITrialActivationButton = props => {
  const {
    activeTrials,
    expiredTrials,
    isMultiTrial,
    isLoadingTrackingProps
  } = useMultiTrialTrackingProps();

  if (isLoadingTrackingProps) {
    return null;
  }

  return /*#__PURE__*/_jsx(TrialActivationButton, Object.assign({}, updateUpgradeData(props), {
    activeTrials: activeTrials,
    expiredTrials: expiredTrials,
    isMultiTrial: isMultiTrial,
    canViewNewSeats: props.canViewNewSeats
  }));
};

export default UITrialActivationButton;